import React from "react";

import { Link } from "gatsby";

import { useTheme } from "@emotion/react";
import styled from "@emotion/styled";

import { storageLocal as storage } from "../../../../utils/StorageHandler";
import useStore from "../../../pages/TechnicShop/store";
import { IconPredefined } from "../../icons/Icon";
import PredefinedIcon, {
    PredefinedIconType,
} from "../../icons/Icon/Predefined";
import { LinkItem, StyledIconContainer } from "../Desktop/TopRow/TopLinkItems";
import { TopRowItemWrapper } from "../Mobile/MobileItemsContainer/MobileModal";
import { CartQuantityIndicator } from "../ShoppingCart";
import useNavigationStore from "../store";

const CartNav = styled.div`
    position: relative;
`;

const TechnicList = () => {
    const { savedProducts } = useStore((state) => ({
        savedProducts: state.savedProducts,
    }));

    const [path] = useNavigationStore((state) => [state.path]);

    if (!storage.get("technic:saved-products")) {
        return null;
    }

    return (
        <TopRowItemWrapper>
            <LinkItem to="/technik/list" active={path === "/technik/list"}>
                <StyledIconContainer>
                    <PredefinedIcon type={PredefinedIconType.bookmark} />
                    {savedProducts?.length > 0 && (
                        <CartQuantityIndicator>
                            {savedProducts?.length ?? 0}
                        </CartQuantityIndicator>
                    )}
                </StyledIconContainer>
                <span>Merkliste</span>
            </LinkItem>
        </TopRowItemWrapper>
    );
};
interface iCartIconProps {
    quantity: number;
    linkToCart?: string;
}
export const Icon = ({
    quantity = 0,
    linkToCart = "/technik/list",
}: iCartIconProps) => {
    const theme = useTheme();
    return (
        <Link to={linkToCart}>
            <CartNav>
                <IconPredefined
                    type={PredefinedIconType.bookmark}
                    size="1em"
                    color={theme.colors.blue.toString()}
                />
                {quantity > 0 && (
                    <CartQuantityIndicator>{quantity}</CartQuantityIndicator>
                )}
            </CartNav>
        </Link>
    );
};
export default TechnicList;
